import React from 'react';
import Vins from '../Vins';

function VinsPage() {
    return (
        <>
            <Vins />
        </>
    )
}

export default VinsPage;
